export const style = {
  wrapper: {
    position: `relative`
  },
  list: {
    position: `relative`,
    margin: 0,
    padding: 0,
    listStyle: `none`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/partials/Slideshow/style/main.js